import { useEffect, useState } from 'react'
import { Capacitor, registerPlugin } from '@capacitor/core'

const Transacciones = registerPlugin('Transacciones')

export default function ActivarDeteccionBancos() {
  const [activo, setActivo] = useState(null)

  async function revisar() {
    try {
      const r = await Transacciones.estaActivo()
      setActivo(r.activo)
    } catch { setActivo(null) }
  }

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return
    revisar()
    const h = () => { if (document.visibilityState === 'visible') revisar() }
    document.addEventListener('visibilitychange', h)
    return () => document.removeEventListener('visibilitychange', h)
  }, [])

  if (!Capacitor.isNativePlatform() || activo === null) return null

  return (
    <section style={{
      background: 'var(--color-surface)',
      border: '1px solid var(--color-border)',
      borderRadius: 24,
      padding: 22,
      marginBottom: 22
    }}>
      <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, color: 'var(--color-text)' }}>
        🏦 Detectar movimientos del banco
      </div>
      <div style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 16, lineHeight: 1.5 }}>
        Calypso lee en tu celular las notificaciones de compras, transferencias y
        dinero recibido para preguntarte si quieres registrarlas. El contenido de
        tus mensajes no sale del celular.
      </div>
      {activo ? (
        <div style={{ fontSize: 13, color: '#22c55e', fontWeight: 700 }}>✅ Activado</div>
      ) : (
        <button
          onClick={() => Transacciones.abrirAjustes()}
          style={{
            width: '100%', padding: '14px 18px', borderRadius: 14, border: 'none',
            background: 'linear-gradient(135deg,#3b82f6,#2563eb)', color: 'white',
            fontWeight: 700, fontSize: 14, cursor: 'pointer'
          }}
        >
          Activar en Ajustes
        </button>
      )}
    </section>
  )
}